<div class="d-md-flex align-items-center bg-white p-3">
  <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> Totale </h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
  </span>
  <div class="ml-auto mt-3 mt-md-0">
    <button type="button" class="btn btn-cyan rounded-pill py-2" *ngIf="permission.isPermitted('gestione-clienti')"
      (click)='add()'>
      <i class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
    </button>
  </div>
  <div class=" mt-3 mt-md-0">
    <button type="button" class="btn btn-orange rounded-pill py-2"
      *ngIf="permission.isPermitted('gestione-clienti') && environment.ClientiAddOn['import']" (click)='Import()'><i
        class="fas fa-upload  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">Importa Clienti</span>
    </button>
  </div>
</div>


<ng-container *ngIf="!(environment.ClientiAddOn['filters']?.length > 0)">

  <div class="d-md-flex align-items-center border-top bg-white p-3">
    <div class="input-group col-md-6">
      <div class="input-group-prepend">
        <label class="input-group-text"> Cerca </label>
      </div>
      <input [(ngModel)]="filter.nome" (ngModelChange)="refreshTable(1)" type="text" name="cerca" class="form-control">
    </div>
    <div class=" col-md-3" *ngIf="type == undefined && environment.ClientiAddOn.ruolo">
      <ng-multiselect-dropdown [settings]="dropdownSettings" placeholder="{{'cliente.tipo' | translate}}"
        [data]="tipologieAsObj" [(ngModel)]="selectedItems" (ngModelChange)="typechange()">
      </ng-multiselect-dropdown>
    </div>
  </div>


  <div class="table-responsive">
    <table class="table bg-white table-hover align-middle mb-0 no-wrap">
      <thead>
        <tr>
          <th>Nominativo</th>
          <th scope="col" *ngIf="environment.ClientiAddOn['codUtenteLista']">Codice utente</th>
          <th scope="col">Email</th>
          <th scope="col">Numero di telefono</th>
          <!--<th scope="col">Tipo</th>-->
          <th scope="col" *ngIf="permission.isPermitted('gestione-clienti')">Azioni</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let co of Lista|slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
          <td class="align-middle" (click)='edit(co)'>
            <span class="text-dark font-medium font-16">{{ co.nominativo }}</span>
            <i class="fas fa-exclamation-triangle text-warning" [ngbTooltip]="'Necessario OK amministrativo'"
              *ngIf="co.checkAmm"></i> &nbsp;&nbsp;
            <!-- <img [src]='co.Imagepath' class="rounded-circle mr-2" alt="" height="45" width="45"> -->

          </td>
          <td class="align-middle" (click)='edit(co)' *ngIf="environment.ClientiAddOn['codUtenteLista']">
            <span class="text-dark font-medium font-16">{{ co.statoCivile }}</span>
            <i class="fas fa-exclamation-triangle text-warning" [ngbTooltip]="'Necessario OK amministrativo'"
              *ngIf="co.checkAmm"></i> &nbsp;&nbsp;
            <!-- <img [src]='co.Imagepath' class="rounded-circle mr-2" alt="" height="45" width="45"> -->

          </td>
          <td class="align-middle">
            <span>
              <!--          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <i-feather name="Mail" class="feather-sm"></i-feather> &nbsp;
              <!--          </span>-->
              <a href="mailto:{{co.email}}" placement="bottom" ngbTooltip="Invia una E-Mail">
                {{ co.email }}
              </a>
              <a href="mailto:{{co.pec}}" placement="bottom" ngbTooltip="Invia una E-Mail">
                {{co.pec}}
              </a>
            </span>
          </td>
          <td class="align-middle" (click)='edit(co)'>
            <span>
              <!--          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">-->
              <i-feather name="phone" class="feather-sm"></i-feather> &nbsp;
              <!--          </span>-->
              {{ co.telefono }}
            </span>
          </td>
          <!--      <td class="align-middle position-relative" (click)='edit(co)'>
          <span>
  &lt;!&ndash;          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">&ndash;&gt;
              <i-feather name="Briefcase" class="feather-sm"></i-feather> &nbsp;
  &lt;!&ndash;          </span>&ndash;&gt;
            <label *ngFor="let Ruolo of co.ruoliObject"> {{ Ruolo.label}} &nbsp; </label>
            <label *ngFor="let tipologia of co.tipiObject"> {{ tipologia.label}} &nbsp; </label>
          </span>
        </td>-->
          <td class="align-middle" *ngIf="permission.isPermitted('gestione-clienti')">
            <a href="javascript:void(0)" class="link text-info font-16 font-medium mr-2" (click)='edit(co)'>
              <i-feather name="edit-3" class="feather-sm"></i-feather>
            </a>
            <a href="javascript:void(0)" ngbTooltip="Abilita cliente"
              *ngIf="environment.ClientiAddOn.enable && !co.active" class="link text-info font-16 font-medium mr-2"
              (click)='enable(co)'>
              <i class="fas fa-check-circle"></i>
            </a>
            <a href="javascript:void(0)" class="link font-16 font-weight-bold" (click)='delete(co)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="Warning(co) != ''" href="javascript:void(0)" [ngbTooltip]="Warning(co)"
              class="link font-16 text-danger font-weight-bold">
              <i class="fas fa-exclamation-triangle text-warning"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>



</ng-container>
<!--
Dynamic
-->
<ng-container *ngIf="environment.ClientiAddOn['filters']?.length > 0">
  <div class="d-flex align-items-center justify-content-between bg-white card-body">
    <a href="javascript:void(0)" class="text-dark" (click)="hide = !hide">Filter</a> &nbsp;
    <a href="javascript:void(0)" (click)="hide = !hide"><i class="fas fa-chevron-down text-dark"
        style="transition: all 0.3s ease-out; transform-origin: top;"
        [style.transform]="!hide? 'rotate(180deg) translate(0, -50%)' : ''"></i></a>
  </div>
  <div *ngIf="hide" class="d-md-flex align-items-center border-top bg-white p-3">
    <app-field-viewer [(Campi)]="environment.ClientiAddOn['filters']" [(Oggetto)]="filter"
      (OnChange)="refreshTable(1)"></app-field-viewer>
  </div>

  <div class="table-responsive d-flex">
    <table class="table bg-white table-hover align-middle mb-0 no-wrap">
      <thead>
        <tr *ngIf="environment.ClientiAddOn['headers']">
          <ng-container *ngFor="let campo of environment.ClientiAddOn['headers']">
            <th scope="col" [ngStyle]="campo.titleStyle" [ngClass]="campo.titleClass" (click)="order(campo)"
              *ngIf="permission.isntOperativeRoles(campo.prohibitedRoles) && permission.isOperativeRoles(campo.AllowedRoles) && headShow(campo)">
              {{campo.nome}}</th>
          </ng-container>
          <th scope="col" [ngStyle]="environment.ClientiAddOn['headerStyle']">Azioni</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of Lista | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
          <ng-container *ngFor="let campo of environment.ClientiAddOn['headers']">
            <td
              *ngIf="permission.isntOperativeRoles(campo.prohibitedRoles) && permission.isOperativeRoles(campo.AllowedRoles) && headShow(campo)"
              (click)='edit(item)'>
              <span class="font-14" [ngClass]="{'badge badge-pill px-3': campoUtility.Colore(campo,item) }"
                [ngStyle]="{'color': campoUtility.Colore(campo,item)?  LightenColor(campoUtility.Colore(campo,item)) : '', 'background-color': campoUtility.Colore(campo,item)}">
                <ng-container *ngFor="let oggetto of campo.oggetti; let i = index">
                  <ng-template [ngIf]="campo.type!= 'object' && campo.inputType == 'date' && item[oggetto]">
                    {{campoUtility.getObj(item, oggetto) | date: 'dd/MM/yyyy'}} &nbsp;
                  </ng-template>
                  <ng-template
                    [ngIf]="campo.type == 'object' && campo.inputType == 'date' && campoUtility.getObj(item, oggetto) ">
                    {{campoUtility.getObj(item, oggetto)[campo.field[i]] | date: 'dd/MM/yyyy'}} &nbsp;
                  </ng-template>
                  <ng-template [ngIf]="campo.type!= 'object' && campo.inputType == 'datetime-local' && item[oggetto]">
                    {{campoUtility.getObj(item, oggetto) | date: 'dd/MM/yyyy HH:mm'}} &nbsp;
                  </ng-template>
                  <ng-template
                    [ngIf]="campo.type == 'object' && campo.inputType == 'datetime-local' && campoUtility.getObj(item, oggetto)">
                    {{campoUtility.getObj(item, oggetto)[campo.field[i]] | date: 'dd/MM/yyyy HH:mm'}} &nbsp;
                  </ng-template>
                  <ng-template
                    [ngIf]="campo.type!= 'object' && campo.inputType != 'date' && campo.inputType != 'datetime-local' && campo.type != 'replace' && campo.type != 'objArray'">
                    {{campoUtility.getObj(item, oggetto)}} &nbsp;
                  </ng-template>
                  <ng-template
                    [ngIf]="campo.type == 'object' && campo.inputType != 'date' && campo.inputType != 'datetime-local' && item[oggetto] && campoUtility.getObj(item, oggetto)">
                    {{campoUtility.getObj(item, oggetto)[campo.field[i]]}} &nbsp;
                  </ng-template>
                  <ng-template
                    [ngIf]="campo.type == 'object' && campo.inputType != 'date' && campo.inputType != 'datetime-local' && !item[oggetto] && campo.oggettisec && campo.oggettisec[i] && item[campo.oggettisec[i]]">
                    {{item[campo.oggettisec[i]][campo.field[i]]}} &nbsp;
                  </ng-template>
                  <ng-template [ngIf]="campo.type == 'replace' ">
                    {{campoUtility.Replace(campo, item, oggetto)}} &nbsp;
                  </ng-template>
                  <ng-template [ngIf]="campo.type == 'objArray' ">
                    <ng-container *ngFor="let obg of campoUtility.getObj(item, oggetto)">
                      {{obg[campo.field[i]]}} &nbsp;
                    </ng-container>
                  </ng-template>
                </ng-container>
              </span>
            </td>
          </ng-container>

          <td class="align-middle" *ngIf="permission.isPermitted('gestione-clienti')">
            <a href="javascript:void(0)" class="link text-info font-16 font-medium mr-2" (click)='edit(item)'>
              <i-feather name="edit-3" class="feather-sm"></i-feather>
            </a>
            <a href="javascript:void(0)" ngbTooltip="Abilita cliente"
              *ngIf="environment.ClientiAddOn.enable && !item?.active" class="link text-info font-16 font-medium mr-2"
              (click)='enable(item)'>
              <i class="fas fa-check-circle"></i>
            </a>
            <a href="javascript:void(0)" ngbTooltip="Invia ad ADHOC"
              *ngIf="environment.ClientiAddOn['SendToAdhoc'] && !item?.codAdhoc"
              class="link text-info font-16 font-medium mr-2" (click)='AddAdhoc(item)'>
              <i class="far fa-paper-plane"></i>
            </a>
            <a href="javascript:void(0)" class="link font-16 font-weight-bold" (click)='delete(item)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="Warning(item) != ''" href="javascript:void(0)" [ngbTooltip]="Warning(item)"
              class="link font-16 text-danger font-weight-bold">
              <i class="fas fa-exclamation-triangle text-warning"></i>
            </a>
          </td>

        </tr>
      </tbody>
    </table>
  </div>

</ng-container>




<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
    [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>